import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <EditFolderDialog folder onUpdateFolder = {folder} onCancel = {} />
 */

class EditFolderDialog extends Component {

	state = {
		name: "",
	}

	readyToUpdate() {
		if (this.state.name === "") {
			return false
		}
		if (this.state.name !== this.props.folder.name) {
			return true
		}
		return false
	}

	componentDidMount() {
		this.setState({
			name: this.props.folder.name,
		})
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Редактировать папку
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					value = {this.state.name}
					label = "Название папки"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.readyToUpdate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUpdateFolder === "function") {
							this.props.onUpdateFolder({
								id: this.props.folder.id,
								name: this.state.name,
							})
						}
					}}
				>Обновить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>
	}
}

export default EditFolderDialog
